/**
 * Created by kaiyan2 on 2017/1/23.
 */
import React from 'react';
import axios from 'axios'
import { generateInfoCard, generateConfigData } from "Common/utility/infoCard";

import { getText } from "Common/utility/utils"


export default class LearningLabModule extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: null
    }
  }


  componentDidMount() {
    if (this.props.config) {
      this.getModuleData(this.props.config);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.config && this.props.config != prevProps.config) {
      this.getModuleData(this.props.config);
    }
  }


  getModuleData(config) {
    if (!config.querySelector("permalink")) {
      return
    }
    const permalink = config.querySelector("permalink").innerText.trim();

    if (!permalink) {
      return
    }

    const url = PubHub.APIHost + `/v1/foundation-search/catalogs/query?type=learninglab&code_name=${permalink}&contentSubtype=module`;

    axios.get(url).then((response) => {
      this.setState({
        permalink,
        items: response.data.items || []
      });
    });
  }

  renderData(items) {
    if (!items || !items.length) return null;
    const data = items[0];

    const labCount = (data.submodules || []).reduce((pre, cur) => pre + (cur.items || []).length, 0);

    const tags = data.tags.map((tag, index) => {
      const splitter = index != data.tags.length - 1 ? ',' : '';
      return <span key={tag} title={tag}
        target="_blank" className="pubhub-learning-lab-module-item-tag-link" data-track-name="learningLabModule:tag"
        data-track-value={tag}>{tag + splitter}</span>
    });

    const hasTags = data.tags.length != 0;

    const hours = ((data.meta.duration || 0) / 60).toFixed(1);
    const duration = data.meta.duration && (
      <div className="col">
        <div className="pubhub-learning-lab-module-item-col">
          <span className="pubhub-learning-lab-module-item-number">{hours}</span>
          <span className="pubhub-learning-lab-module-item-type">hours</span>
        </div>
      </div>
    )

    return (
      <div className="pubhub-learning-lab-module-item">
        <div className="row ">
          <div className="col pubhub-learning-lab-module-item-title">
            <a href={"/learning/modules/" + this.state.permalink}
              target="_blank" data-track-name="learningLabModule:title"
              data-track-value={data.name} rel="noopener noreferrer">{data.name}</a>
          </div>
        </div>
        <div className="row ">
          <div className="col pubhub-learning-lab-module-item-info">

            <div className="row pubhub-learning-lab-module-item-description">
              <div className="col">
                {data.description || data.contentFullText}
              </div>
            </div>

            <div className={"row pubhub-learning-lab-module-item-tags" + (hasTags ? ' has-tags' : '')}>
              <div className="col">
                {tags}
              </div>
            </div>

            <div className="row pubhub-learning-lab-module-item-data">
              <div className="col">
                <div className="pubhub-learning-lab-module-item-col">
                  <span className="pubhub-learning-lab-module-item-number">{labCount}</span>
                  <span className="pubhub-learning-lab-module-item-type">Labs</span>
                </div>
              </div>
              {duration}
            </div>
          </div>
        </div>
      </div>
    );
  }


  render() {
    const { config, type } = this.props;

    if (!config) {
      return <span className="pubhub-loading"></span>
    }

    const el_data = generateConfigData(config);

    const color = getText(config, "color");

    var items = <span className="pubhub-loading"></span>

    if (this.state.items) {
      items = this.renderData(this.state.items);
    }

    const typeClass = type ? "pubhub-learning-lab-module-" + type : "";

    const top_border = (() => {
      if (!type) {
        return null
      }


      const style = {
        background: color === "" ? null : color
      };

      return <div className="row pubhub-learning-lab-module-top-banner"
        style={style} />

    })();

    const titleSection = (
      <div className="row">
        <div className="col pubhub-learning-lab-module-title" style={{ "color": color + " !important" }}>
          {el_data.title}
        </div>
      </div>
    )

    return (
      <div className={"pubhub-learning-lab-module " + typeClass}>
        <div className="container">
          {titleSection}
          {top_border}
          {items}
        </div>
      </div>
    );
  }
}

